// invites.actions.ts
import { createAction, props } from '@ngrx/store';
import {
  AcceptInvitationRequest,
  AcceptInvitationResponse,
  ResolveInvitationResponse,
} from '../../models/invitation/inviation.model';

// invitation create
export const createInvitation = createAction(
  '[Invites] Invitation Create',
  props<{ email: string }>(),
);

export const createInvitationSuccess = createAction('[Invites] Invitation Create Success');

// preview
export const resolveInvitation = createAction(
  '[Invites] Resolve Invitation',
  props<{ token: string }>(),
);

export const resolveInvitationSuccess = createAction(
  '[Invites] Resolve Invitation Success',
  props<{ payload: ResolveInvitationResponse }>(),
);

// accept
export const acceptInvitation = createAction(
  '[Invites] Invitation Accept',
  props<{ payload: AcceptInvitationRequest }>(),
);

export const acceptInvitationSuccess = createAction(
  '[Invites] Invitation Accept Success',
  props<{ payload: AcceptInvitationResponse }>(),
);
